import { useState, useEffect, useCallback } from 'react';
import { DEFAULT_EVENT_SETTINGS } from '../config/events.js';
import { stateService } from '../core/StateService.js';

export function useEventSettings() {
  const [settings, setSettings] = useState(() => stateService.getAdminSettings());

  useEffect(() => {
    const unsubscribe = stateService.subscribe((data, type) => {
      if (type === 'adminSettings') setSettings(data);
    });

    // Frontend is alive -> Send Ping to answer Admin Dashboard
    if (stateService.bc) {
      stateService.bc.postMessage({ type: 'tef-pong', source: 'frontend' });
    }

    return () => unsubscribe();
  }, []);

  const updateSettings = useCallback((updates) => {
    setSettings(prev => {
      const merged = { ...prev, ...updates };
      stateService.saveAdminSettings(merged);
      return merged;
    });
  }, []);

  const updateEffect = useCallback((effectName, enabled) => {
    setSettings(prev => {
      const merged = {
        ...prev,
        effects: { ...prev.effects, [effectName]: enabled }
      };
      stateService.saveAdminSettings(merged);
      return merged;
    });
  }, []);

  const updateBackgroundColors = useCallback((colors) => {
    setSettings(prev => {
      const merged = {
        ...prev,
        backgroundColors: { ...prev.backgroundColors, ...colors }
      };
      stateService.saveAdminSettings(merged);
      return merged;
    });
  }, []);

  return {
    settings,
    updateSettings,
    updateEffect,
    updateBackgroundColors,
    resetSettings: () => {
      stateService.saveAdminSettings({ ...DEFAULT_EVENT_SETTINGS });
    }
  };
}
